export default __webpack_public_path__ + "static/media/close.d6b9e1f1.svg";